import React from 'react';
import { Alert } from 'react-bootstrap';

/**
 * @param {{ message?: string, errorLines?: string[], status?: number|null, variant?: string }} props
 */
const OrderConfirmationErrorAlert = ({
  message = '',
  errorLines = [],
  status = null,
  variant = 'danger',
}) => {
  const lines =
    errorLines.length > 0
      ? errorLines
      : message
        ? message.split('\n').filter(Boolean)
        : [];

  if (!lines.length) return null;

  return (
    <Alert variant={variant} className="py-2 small mb-3">
      {status != null && (
        <div className="text-muted mb-1">Server response: HTTP {status}</div>
      )}
      {lines.length === 1 ? (
        <div>{lines[0]}</div>
      ) : (
        <ul className="mb-0 ps-3">
          {lines.map((line, idx) => (
            <li key={idx}>{line}</li>
          ))}
        </ul>
      )}
    </Alert>
  );
};

export default OrderConfirmationErrorAlert;
